import { Route, Routes } from "react-router-dom";

import K1DataUpload from "./K1DataUpload/main";
import K1Documents from "./K1Documents/main";
import K1PeFunds from "./K1PeFunds/main";
import K1Issuers from "./K1Issuers/main";
import K1Positions from "./K1Positions/main";
import K1CapitalAccount from "./K1CapitalAccount/main";
import K1Mastersheet from "./K1Mastersheet/main";
import K1Analytics from "./K1Analytics/main";
import K1LevelAnalytics from "./K1LevelAnalytics/main";
import K1PositionsIssuers from "./K1PositionsIssuers/main";
import K1ManagementCompanies from "./K1ManagementCompanies/main";
import K1FundsPortfolio from "./K1FundsPortfolio/main";
import K1EmailLogs from "./K1EmailLogs/main";
import K1PositionsIssuersReconciliation from "./K1PositionsIssuersReconciliation/main";
import K1RawData from "./K1RawData/main";

export default function K1Routes() {
  return (
    <Routes>
      <Route path="k1_data_upload/*" element={<K1DataUpload />} />
      <Route path="k1_documents/*" element={<K1Documents />} />
      <Route path="k1_pe_funds/*" element={<K1PeFunds />} />
      <Route path="k1_issuers/*" element={<K1Issuers />} />
      <Route path="k1_positions/*" element={<K1Positions />} />
      <Route path="k1_capital_account/*" element={<K1CapitalAccount />} />
      <Route path="k1_mastersheet/*" element={<K1Mastersheet />} />
      <Route path="k1_analytics/*" element={<K1Analytics />} />
      <Route path="k1_level_analytics/*" element={<K1LevelAnalytics />} />
      <Route path="k1_positions_issuers/*" element={<K1PositionsIssuers />} />
      <Route
        path="k1_management_companies/*"
        element={<K1ManagementCompanies />}
      />
      <Route path="k1_funds_portfolio/*" element={<K1FundsPortfolio />} />
      <Route path="k1_email_logs/*" element={<K1EmailLogs />} />
      <Route
        path="k1_reconciliation/*"
        element={<K1PositionsIssuersReconciliation />}
      />
      <Route
        path="k1_positions_issuers_reconciliation/*"
        element={<K1PositionsIssuersReconciliation />}
      />
      <Route path="k1_raw_data/*" element={<K1RawData />} />
    </Routes>
  );
}
